import React, { useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { Card, Grid, Typography } from '@material-ui/core';
import { isEmpty } from 'lodash';
import RecapNoticeDeficiency from 'containers/ExpertExpertise/Recap/RecapNoticeDeficiency';
import ValidationDialog from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/NoticeDeficiency/ValidationDialog';
import { translate } from 'containers/services/translate';
import warning from 'images/warning.svg';

import {
  StyledCard,
  SpacingTopBottom,
  StyledText,
} from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/styles';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import RejectionDialog from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/NoticeDeficiency/RejectionDialog';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  FEE_NOTE_STEP,
  MISSION_EXPERISE_VICTIM_STATUS,
} from 'containers/data-structure';

export interface NoticeDeficiencyProps {
  intl: IntlShape;
  missionPostPone: any;
  requestMakeDecisionMissionNoticeDeficiency: Function;
  claimId: number;
  isLawyer?: boolean;
  feeNotes: any;
  missionPostPoneExpertise: any;
  claimNumber: string;
  setOpenFeeNoteDialog: Function;
  requestGetDocByDocumentumId: Function;
}

const NoticeDeficiency: React.FC<NoticeDeficiencyProps> = props => {
  const [openValidationModal, setOpenValidationModal] = useState(false);
  const [openRejectionModal, setOpenRejectionModal] = useState(false);

  const [selectedNotice, setSelectedNotice] = useState({});

  const pendingFeeNote =
    !isEmpty(props.feeNotes) &&
    props.feeNotes.filter(
      (element: any) =>
        (!element.status ||
          element.status === MISSION_EXPERISE_VICTIM_STATUS.PENDING) &&
        element.step === FEE_NOTE_STEP.NOTICE_DEFICIENCY,
    ).length;
  return (
    <Grid>
      <Grid item style={SpacingTopBottom} xs={6}>
        {pendingFeeNote > 0 && !props.isLawyer ? (
          <Card style={StyledCard} elevation={0}>
            <Grid container direction="row">
              <Grid item xs={1}>
                <img src={warning} alt="warning" />
              </Grid>
              <Grid item>
                <Typography style={StyledText}>
                  {translate({ ...messages.feeNoteNoticeWarningTitle }, props, {
                    pendingFeeNote: pendingFeeNote,
                  })}
                </Typography>
              </Grid>
            </Grid>
          </Card>
        ) : (
          <></>
        )}
      </Grid>
      <RecapNoticeDeficiency
        title={translate({ ...messages.noticeDeficiency }, props)}
        missionPostPone={props.missionPostPone}
        isManager={!props.isLawyer}
        openValidationModal={() => setOpenValidationModal(true)}
        openRejectionModal={() => setOpenRejectionModal(true)}
        setSelectedNotice={setSelectedNotice}
        requestUpdateMissionPostPone={() => {}}
        uploadDocument={() => {}}
        uploadedDocument={({} as unknown) as IUploadedDocument}
        resetUploadedDocument={() => {}}
        sagis_code={null}
        missionPostPoneExpertise={props.missionPostPoneExpertise}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
      <ValidationDialog
        open={openValidationModal}
        onClose={() => setOpenValidationModal(false)}
        validateDialog={props.requestMakeDecisionMissionNoticeDeficiency}
        recap={selectedNotice}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
      />
      <RejectionDialog
        open={openRejectionModal}
        onClose={() => setOpenRejectionModal(false)}
        validateDialog={props.requestMakeDecisionMissionNoticeDeficiency}
        recap={selectedNotice}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
      />
    </Grid>
  );
};
export default injectIntl(NoticeDeficiency);
